import { InjectionToken } from '@angular/core';

export class SacAIPData {
  applicationPath: string;
  firmName: string;
  firmID: string;
  firmType: string;
  contextID: string;
  contextType: string;
  userName: string;
  sessionId: string;
  context: string;
  isEmployee: boolean;
}

export const APP_CONTEXT = new InjectionToken<SacAIPData>('AppContext');
